<script>
// @ is an alias to /src
import LoginLinks from "@/components/LoginLinks.vue";
import LoginPopupLinks from "@/components/LoginPopupLinks.vue";
import { AUTH_REQUEST } from "../store/actions/auth";
import { GET_ACCESS_CODE } from "../store/actions/auth";
import { SHOW_LOADER } from "../store/actions/common";
import { mapGetters, mapActions } from "vuex";
import { CONFIG } from "../config";
import { i18n } from "../i18n";
import { localizationMixin } from "../mixins/localizationMixin";
import { utilityMixin } from "../mixins/utilityMixin";
import { getDobYears } from "../utilities/util";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import Dialog from "primevue/dialog";

import { load } from "recaptcha-v3";
const siteKey = "6LctF8wfAAAAAPs3CNbBBrTS-sM2Pz2PnV_ZPCg7";
export default {
  name: "Login",
  mixins: [localizationMixin, utilityMixin],
  components: {
    LoginLinks,
    LoginPopupLinks,
    InputText,
    Dropdown,
    Button,
    Dialog,
  },
  mounted: function () {
    this.getAccessCode();
    window.openResource = this.openResource;
    window.openResource = this.openResource;
  },
  computed: {
    ...mapGetters(["getClientConfig", "loginAttempts", "selectedLanguage"]),

    /* NEW computed that controls grayout behaviour:
       - If TSDS has a value -> do NOT grayout
       - If TSDS input is focused -> do NOT grayout
       - Otherwise (not focused, no value) -> grayout
       Additionally, when Access Code input has focus, TSDS should be grayout (unless TSDS has a value).
    */
    tsdsGrayout() {
      var tsdsHasValue = !!this.tsdsId && String(this.tsdsId).trim() !== "";
      if (tsdsHasValue) return false;
      if (this.tsdsFocused) return false;
      if (this.accessFocused) return true;
      return true;
    },

    monthsArray: function () {
      return [
        { mtext: this.$t("January"), mval: "0" },
        { mtext: this.$t("February"), mval: "1" },
        { mtext: this.$t("March"), mval: "2" },
        { mtext: this.$t("April"), mval: "3" },
        { mtext: this.$t("May"), mval: "4" },
        { mtext: this.$t("June"), mval: "5" },
        { mtext: this.$t("July"), mval: "6" },
        { mtext: this.$t("August"), mval: "7" },
        { mtext: this.$t("September"), mval: "8" },
        { mtext: this.$t("October"), mval: "9" },
        { mtext: this.$t("November"), mval: "10" },
        { mtext: this.$t("December"), mval: "11" },
      ];
    },
    datevalid: function () {
      return Date.now();
    },
    termsofUse() {
      return (
        CONFIG.PORTAL_BASE_URL +
        this.getClientConfig.clientname +
        "/" +
        this.selectedLanguage +
        "/Family+Portal+Terms+of+Use.pdf"
      );
    },
    loginTimeout() {
      var duration = new Date(Date.now()) - new Date(this.loginAttempts.timestamp);
      var seconds = Math.floor(duration / 1000);
      // if duration is gretaer than 4 hours clear login attempts count
      if (Math.floor(seconds / (60 * 60)) >= 4) {
        this.CLEAR_LOGIN_ATTEMPTS();
      }
      var waitTimeInSeconds = (this.loginAttempts.count / 3) * 120;
      if (
        this.loginAttempts.count >= 3 &&
        this.loginAttempts.count % 3 == 0 &&
        seconds >= 0 &&
        seconds <= waitTimeInSeconds
      ) {
        this.countDownTimer(waitTimeInSeconds - seconds);
        return (waitTimeInSeconds - seconds) * 1000;
      }
      return 0;
    },
    snackbar: {
      get() {
        return this.loginTimeout > 0;
      },
      set() {},
    },
    locale() {
      return i18n.global.locale;
    },
    headerFormat() {
      let header = this.$t("Login.info");
      return header.charAt(0).toUpperCase() + header.toLocaleLowerCase().slice(1);
    },
  },

  methods: {
    ...mapActions(["SET_LOGIN_ATTEMPTS", "CLEAR_LOGIN_ATTEMPTS", "HIDE_LOADER"]),
    combinedTOU() {
      const linkText = this.$t("App.TOU");
      const url = this.termsofUse;
      return this.$t("Login.termsofUse", {
        link: `<a href="#" onclick="openResource('${url}')">${linkText}</a>`,
      });
    },
    formatInput(name) {
      return name.replace(/[\u2018\u2019]/g, "'"); //replace curved singlequotes to support login from ios (disabling smart punctuation)
    },
    getAccessCode() {
      if (sessionStorage.getItem("fromaccess")) {
        this.accessCode = sessionStorage.getItem("accesscode");
      } else {
        this.accessCode = null;
      }
    },
    clearFormErrors() {
      this.errors = [];
      this.txerrors.accessCode = "";
      this.txerrors.tsdsId = "";
      this.txerrors.general = "";
      this.showErrorMessages = false;
    },
    validateAccessCode() {
      this.txerrors.accessCode = "";
      const val = (this.accessCode || "").toString().trim();
      if (!val) return true; // empty is allowed if TSDS provided
      if (!/^[A-Za-z0-9]{6}$/.test(val)) {
        //this.txerrors.accessCode = "Access code must be exactly 6 alphanumeric characters."; //TODO
        this.txerrors.accessCode =
          this.$t("Login.error") + " " + this.$t("Login.error.access_code_length");
        return false;
      }
      return true;
    },

    validateTsdsId() {
      this.txerrors.tsdsId = "";
      const val = (this.tsdsId || "").toString().trim();
      if (!val) return true; // empty is allowed if access code provided
      // if (!/^[0-9]{5,12}$/.test(val)) {
      //   this.txerrors.tsdsId = "TSDS / PEIMS ID must be 5–12 digits."; //TODO:
      //   return false;
      // }
      return true;
    },
    /* the overall either-or validation */
    validateEitherOr() {
      this.txerrors.general = "";
      // If both empty -> error
      const accessVal = (this.accessCode || "").toString().trim();
      const tsdsVal = (this.tsdsId || "").toString().trim();
      if (!accessVal && !tsdsVal) {
        this.txerrors.general = this.$t("Login.error") + " " + this.$t("Login.error.eitheror");
        return false;
      }
      // run per-field rules
      const accessOk = this.validateAccessCode();
      const tsdsOk = this.validateTsdsId();
      // if both present, both must be valid; if only one present, that one must be valid
      return accessOk && tsdsOk;
    },
    onSignInClick(e) {
      if (e && typeof e.preventDefault === "function") e.preventDefault();

      // clear previous errors
      this.txerrors.accessCode = "";
      this.txerrors.tsdsId = "";
      this.txerrors.general = "";
      this.errors = [];
      this.notValid = false;

      // Validation logic
      if (this.getClientConfig.clientname === "texas") {
        if (!this.validateEitherOr()) this.notValid = true;
      } else {
        if (!this.accessCode) this.notValid = true;
        if (this.accessCode && this.accessCode.length < 6) this.notValid = true;
      }

      if (!this.monthSelected) this.notValid = true;
      if (!this.daySelected) this.notValid = true;
      if (!this.yearSelected) this.notValid = true;
      if (!this.fName) this.notValid = true;

      if (this.notValid) {
        this.showErrorMessages = true;
        this.$nextTick(() => {
          // Find the first rendered error span with an ID
          const firstError = this.$el.querySelector("span.error[id]");
          if (!firstError) return;

          const errorId = firstError.id;

          // Find the form field that references this error via aria-describedby
          let target = this.$el.querySelector(`[aria-describedby~="${errorId}"]`);

          if (!target) {
            // Fallback: first focusable field in form
            target = this.$el.querySelector("input, select, textarea");
          }

          if (target) {
            // PrimeVue Dropdown root is a <div>; focus its inner interactive span instead
            if (!["INPUT", "SELECT", "TEXTAREA"].includes(target.tagName)) {
              const inner = target.querySelector('[data-pc-section="input"]');
              if (inner) target = inner;
            }
            target.setAttribute("tabindex", "-1");
            target.focus();
          }
        });
        return;
      } else {
        this.showErrorMessages = false;
      }

      // If accessCode exists -> run auth request immediately.
      if (this.accessCode) {
        this.formSubmit(); // no reCAPTCHA needed for this path
        return;
      }

      // If tsdsId exists -> run reCAPTCHA then call formSubmit with token
      if (this.tsdsId) {
        if (typeof load !== "function" || typeof siteKey === "undefined") {
          console.warn("reCAPTCHA loader or siteKey not available; proceeding without token");
          this.formSubmit();
          return;
        }

        load(siteKey)
          .then(recaptcha => recaptcha.execute("AccessCode"))
          .then(token => {
            this.reCaptchaToken = token;
            this.formSubmit(token); // pass token as single arg
          })
          .catch(error => {
            console.error("reCAPTCHA failed:", error);
            this.errors.push(this.$t("AccessCode.recaptcha_failed") || "reCAPTCHA failed");
            this.showErrorMessages = true;
          });

        return;
      }

      // If neither present, nothing to do (should've been caught by validation)
    },

    /**
     * Primary submit logic. Accepts optional recaptchaToken used by the TSDS flow.
     */
    formSubmit(recaptchaToken = null) {
      // defensive initialization
      this.txerrors.accessCode = this.txerrors.accessCode || "";
      this.txerrors.tsdsId = this.txerrors.tsdsId || "";
      this.txerrors.general = this.txerrors.general || "";
      this.errors = this.errors || [];

      sessionStorage.clear();

      // compute shared values once to avoid redeclare errors
      const dob = new Date(Date.UTC(this.yearSelected, this.monthSelected, this.daySelected));
      const fname = this.formatInput(this.fName);

      // Access Code path
      if (this.accessCode) {
        const accessCode = this.accessCode;
        this.$store.dispatch(SHOW_LOADER);
        this.$store
          .dispatch(AUTH_REQUEST, {
            Name: fname,
            AccessCode: accessCode,
            DateOfBirth: dob,
            ClientName: this.getClientConfig.clientname,
            FetchHistoricalData: this.getClientConfig.fetchHistoricalData,
          })
          .then(() => {
            this.CLEAR_LOGIN_ATTEMPTS();
            const returnUrl = this.$route.query.returnUrl;
            if (returnUrl) {
              this.$router.push(returnUrl);
            } else {
              this.$router.push("/home");
            }
          })
          .catch(err => {
            if (err && err.response !== undefined) {
              this.SET_LOGIN_ATTEMPTS();
            }
          })
          .finally(() => {
            if (typeof this.HIDE_LOADER === "function") this.HIDE_LOADER();
          });

        return;
      }

      // TSDS path: requires recaptchaToken (either passed or previously stored)
      if (this.tsdsId) {
        const tokenToUse = recaptchaToken || this.reCaptchaToken || null;
        if (!tokenToUse) {
          console.warn("No reCAPTCHA token available for TSDS flow");
          this.errors.push(
            this.$t("AccessCode.recaptcha_missing") || "Security verification failed"
          );
          this.showErrorMessages = true;
          return;
        }

        this.reCaptchaToken = tokenToUse;
        const tsdsId = this.tsdsId;

        this.$store.dispatch(SHOW_LOADER);
        this.$store
          .dispatch(GET_ACCESS_CODE, {
            Name: fname,
            TSDSid: tsdsId,
            DateOfBirth: dob,
            ClientName: this.getClientConfig.clientname,
            RecaptchaToken: this.reCaptchaToken,
          })
          .then(async response => {
            if (response && response.data && response.data.accesscode) {
              this.CLEAR_LOGIN_ATTEMPTS();
              sessionStorage.setItem("fname", fname);
              sessionStorage.setItem("dob", dob.toISOString());
              this.$router.push("/AccessCodeResult");
            } else {
              this.SET_LOGIN_ATTEMPTS();
              this.errors.push(this.$t("AccessCode.notFound"));
              this.showErrorMessages = true;
            }
          })
          .catch(async err => {
            if (err && err.response !== undefined) this.SET_LOGIN_ATTEMPTS();
            this.errors.push(this.$t("Login.loginUnsuccessful"));
            this.showErrorMessages = true;
          })
          .finally(() => {
            if (typeof this.HIDE_LOADER === "function") this.HIDE_LOADER();
          });

        return;
      }
    },
    openResource(resource) {
      window.open(resource, "_blank");
    },

    showTsdsIdModal() {
      this.tsdsIdModalVisible = true;
    },
    onTsdsDialogHide() {
      this.$nextTick(() => {
        const btn = this.$refs.tsdsInfoBtn;
        if (btn) btn.focus();
      });
    },
    onTsdsIdModalCloseBtnClick(value = false) {
      this.tsdsIdModalVisible = !!value;
    },
    // new focus handlers: when TSDS gains focus, clear the Access Code input
    onTsdsFocus() {
      this.tsdsFocused = true;
      this.tsdsTouched = true;
    },
    onTsdsBlur() {
      this.tsdsFocused = false;
      this.tsdsTouched = true;
    },
    // new: when Access Code gains focus, clear the TSDS input
    onAccessFocus() {
      this.accessFocused = true;
      this.accessTouched = true;
    },
    onAccessBlur() {
      this.accessFocused = false;
      this.accessTouched = true;
    },

    countDownTimer(value) {
      this.countDown = value;
      if (this.countDown != undefined && this.countDown > 0) {
        setTimeout(() => {
          this.countDownTimer();
        }, 1000);
      }
    },
  },

  data: () => ({
    daysArray: Array(31)
      .fill(1)
      .map((e, i) => i + 1),
    yearsArray: getDobYears(),
    monthSelected: null,
    daySelected: null,
    yearSelected: null,
    accessCode: null,
    fName: null,
    isValid: false,
    notValid: false, // added so formSubmit can use it
    errors: [],
    txerrors: {
      accessCode: "",
      tsdsId: "",
      general: "",
    },
    showErrorMessages: false,
    countDown: 0,
    tsdsId: null,
    tsdsIdModalVisible: false,
    // focus flags used by tsdsGrayout computed
    tsdsFocused: false,
    accessFocused: false,
    tsdsTouched: false,
    accessTouched: false,
  }),
  watch: {
    loginAttempts: {
      immediate: true,
      deep: true,
      handler() {},
    },
    loginTimeout: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value > 0) {
          this.monthSelected = null;
          this.daySelected = null;
          this.yearSelected = null;
          this.accessCode = null;
          this.tsdsId = null;
          this.fName = null;
        }
      },
    },
    locale: {
      immediate: true,
      deep: true,
      handler() {
        this.errors = [];
        (this.txerrors.accessCode = ""),
          (this.txerrors.tsdsId = ""),
          (this.txerrors.general = ""),
          (this.showErrorMessages = false);
      },
    },
  },
};
</script>

<template>
  <!-- <div class="grid" justify="center"> -->
  <div id="mainWrapper" aria-hidden="false" :class="getClientConfig.clientname">
    <div id="login_info">
      <form ref="form" class="login_form" novalidate="true">
        <fieldset>
          <legend class="pt-3 login_legend">{{ headerFormat }}</legend>

          <span class="login_note" v-if="$t('Login.note')">
            {{ $t("Login.note") }}
          </span>

          <!-- TX Access code -->
          <div v-if="getClientConfig.clientname === 'texas'">
            <div class="access-row">
              <div class="field">
                <label class="field-label" id="accessCodeLabel" for="access_code">
                  {{ translate("Login.access_code") }}
                </label>

                <InputText
                  id="access_code"
                  class="field-input"
                  :disabled="snackbar"
                  v-model="accessCode"
                  :placeholder="translate('Login.access_code_aria_label')"
                  aria-required="required"
                  aria-labelledby="accessCodeLabel "
                  aria-describedby="uniqueStudentAccessCodeError"
                  @focus="onAccessFocus"
                  @blur="onAccessBlur"
                />
                <span
                  class="error"
                  role="alert"
                  id="uniqueStudentAccessCodeError"
                  v-if="showErrorMessages && this.txerrors.accessCode"
                  :aria-label="translate('Login.error.access_code')"
                  >{{ this.txerrors.accessCode }}</span
                >
              </div>
              <!-- Separator with vertical pipe and "or" -->
              <!-- <div class="separator"> -->
              <span class="or-text">{{ safeT("Or", "or") }}</span>
              <!-- </div> -->
              <div class="field id-field">
                <div class="label-row">
                  <label class="field-label" id="tsdsideLabel" for="tsds_id">
                    {{ translate("AccessCode.tsdsLabel") }}{{ safeT("colon", ":") }}
                  </label>

                  <button
                    type="button"
                    class="info-btn"
                    ref="tsdsInfoBtn"
                    @click="showTsdsIdModal"
                    aria-haspopup="dialog"
                    :aria-expanded="tsdsIdModalVisible.toString()"
                    aria-controls="tsdsDialog"
                    :aria-label="translate('AccessCode.tsdsInfoLabel')"
                  >
                    <span aria-hidden="true" class="svg-icon svg-icon-info"></span>
                  </button>

                  <Dialog
                    id="tsdsDialog"
                    :visible="tsdsIdModalVisible"
                    @update:visible="val => (tsdsIdModalVisible = val)"
                    @hide="onTsdsDialogHide"
                    modal
                    class="dialog_width tsds-id-modal"
                    :show-header="false"
                    role="dialog"
                    aria-labelledby="tsdsDialogTitle"
                    aria-describedby="tsdsDialogDesc"
                  >
                    <h2 id="tsdsDialogTitle" class="sr-only">{{ translate("Login.tsdsPeimsInfo") }}</h2>

                    <p id="tsdsDialogDesc" class="dialog_content_position">
                      {{ translate("AccessCode.tsdsDesc") }}
                    </p>

                    <template #footer>
                      <Button
                        :label="translate('popup.Close').toUpperCase()"
                        class="dialog_close"
                        text
                        severity="secondary"
                        autofocus
                        @click="onTsdsIdModalCloseBtnClick(false)"
                      />
                    </template>
                  </Dialog>
                </div>
                <InputText
                  class="field-input tsds-input"
                  id="tsds_id"
                  v-model="tsdsId"
                  @focus="onTsdsFocus"
                  @blur="onTsdsBlur"
                  :class="{ grayout: tsdsGrayout }"
                  aria-required="required"
                  type="password"
                  :placeholder="translate('AccessCode.tsdsLabelHint')"
                  :aria-label="translate('AccessCode.tsdsLabelHint')"
                  aria-describedby="tsdsIDError"
                />
                <span
                  class="error"
                  role="alert"
                  id="tsdsIDError"
                  v-if="showErrorMessages && this.txerrors.tsdsId"
                  :aria-label="translate('AccessCode.error.tsdsId')"
                  >{{ this.txerrors.tsdsId }}</span
                >
              </div>
            </div>
            <span
              class="error eitheror-error"
              role="alert"
              id="eitherorError"
              v-if="showErrorMessages && this.txerrors.general"
              :aria-label="this.txerrors.general"
              >{{ this.txerrors.general }}</span
            >
          </div>
          <!-- non TX client's access code-->
          <div class="loginFieldContainer flex pb-2" v-else>
            <label class="labelcontainer" id="accessCodeLabel" for="access_code">
              {{ translate("Login.access_code") }}
            </label>
            <div class="col-6 p-0">
              <InputText
                class="darker-placeholder"
                style="width: 100%"
                :disabled="snackbar"
                v-model="accessCode"
                size="small"
                id="access_code"
                :placeholder="translate('Login.access_code_aria_label')"
                aria-required="required"
                aria-labelledby="accessCodeLabel"
                :aria-describedby="
                  showErrorMessages && accessCode == null
                    ? 'accessCodeErrorNull'
                    : showErrorMessages && accessCode && accessCode.length < 6
                    ? 'accessCodeErrorLength'
                    : null
                "
              />
              <span
                class="error"
                role="alert"
                id="accessCodeErrorNull"
                v-if="showErrorMessages && accessCode == null"
                :aria-label="translate('Login.error.access_code')"
                >{{ translate("Login.error") + " " + translate("Login.error.access_code") }}</span
              >
              <span
                class="error"
                role="alert"
                id="accessCodeErrorLength"
                v-else-if="showErrorMessages && accessCode && accessCode.length < 6"
                :aria-label="translate('Login.error.access_code_length')"
                >{{
                  translate("Login.error") + " " + translate("Login.error.access_code_length")
                }}</span
              >
            </div>
          </div>
          <!-- DOB section -->
          <fieldset class="loginFieldContainer flex pb-2" id="dobFieldset">
            <legend class="labelcontainer" id="dobLabel">{{ translate("Login.dobLabel") }}</legend>
            <div class="flex gap-2 loginDateContainer">
              <!--Birth Month -->
              <div class="selectContainer">
                <label class="labelcontainer" id="dobMonthLabel" for="dobMonth">{{
                  translate("Login.dobMonthLabel")
                }}</label>
                <Dropdown
                  class="darker-placeholder"
                  id="dobMonth"
                  :disabled="snackbar"
                  v-model="monthSelected"
                  :options="monthsArray"
                  optionLabel="mtext"
                  optionValue="mval"
                  :placeholder="translate('Login.dob_month_aria_label')"
                  aria-required="required"
                  :aria-label="translate('Login.dobMonthLabel')"
                  aria-haspopup="listbox"
                  aria-controls="dobMonth_list"
                  aria-labelledby="dobMonthLabel"
                  :aria-describedby="
                    showErrorMessages && monthSelected == null ? 'dobMonthError' : null
                  "
                  aria-expanded="false"
                  style="width: 100%"
                  appendTo="self"
                />
                <span
                  class="error"
                  role="alert"
                  id="dobMonthError"
                  aria-live="assertive"
                  v-if="showErrorMessages && monthSelected == null"
                  :aria-label="translate('Login.error.month')"
                  >{{ translate("Login.error") + " " + translate("Login.error.month") }}</span
                >
              </div>
              <!--Birth Day -->
              <div class="selectContainer">
                <label class="labelcontainer" id="dobDayLabel" for="dobDay">{{
                  translate("Login.dobDayLabel")
                }}</label>
                <Dropdown
                  class="darker-placeholder"
                  id="dobDay"
                  :disabled="snackbar"
                  v-model="daySelected"
                  :options="daysArray"
                  :placeholder="translate('Login.dob_day_aria_label')"
                  aria-required="required"
                  :aria-label="translate('Login.dobDayLabel')"
                  aria-haspopup="listbox"
                  aria-controls="dobDay_list"
                  aria-labelledby="dobDayLabel"
                  :aria-describedby="
                    showErrorMessages && daySelected == null ? 'dobDayError' : null
                  "
                  aria-expanded="false"
                  style="width: 100%"
                  appendTo="self"
                />
                <span
                  class="error"
                  role="alert"
                  id="dobDayError"
                  aria-live="assertive"
                  v-if="showErrorMessages && daySelected == null"
                  :aria-label="translate('Login.error.day')"
                  >{{ translate("Login.error") + " " + translate("Login.error.day") }}</span
                >
              </div>

              <!--Birth Year -->
              <div class="selectContainer">
                <label class="labelcontainer" id="dobYearLabel" for="dobYear">{{
                  translate("Login.dobYearLabel")
                }}</label>
                <Dropdown
                  class="darker-placeholder"
                  id="dobYear"
                  :disabled="snackbar"
                  v-model="yearSelected"
                  :options="yearsArray"
                  :placeholder="translate('Login.dob_year_aria_label')"
                  aria-required="required"
                  :aria-label="translate('Login.dobYearLabel')"
                  aria-haspopup="listbox"
                  aria-controls="dobYear_list"
                  aria-labelledby="dobYearLabel"
                  :aria-describedby="
                    showErrorMessages && yearSelected == null ? 'dobYearError' : null
                  "
                  style="width: 100%"
                  appendTo="self"
                />
                <span
                  class="error"
                  role="alert"
                  id="dobYearError"
                  aria-live="assertive"
                  v-if="showErrorMessages && yearSelected == null"
                  :aria-label="translate('Login.error.year')"
                  >{{ translate("Login.error") + " " + translate("Login.error.year") }}</span
                >
              </div>
            </div>
          </fieldset>

          <!-- First name -->
          <div class="loginFieldContainer flex">
            <label class="labelcontainer" id="loginFN_label">
              <template v-if="getClientConfig.clientname === 'texas'">
                {{ translate("Login.Tx_loginFN_label") }}
              </template>
              <template v-else>
                {{ translate("Login.loginFN_label") }}
              </template>
            </label>
            <div class="col-8 p-0">
              <InputText
                class="darker-placeholder"
                style="width: 100%"
                :disabled="snackbar"
                v-model="fName"
                size="small"
                id="first_name"
                :placeholder="
                  getClientConfig.clientname === 'texas'
                    ? translate('AccessCode.firstname_aria_label')
                    : translate('Login.firstname_aria_label')
                "
                aria-required="required"
                aria-labelledby="loginFN_label"
                :aria-describedby="showErrorMessages && fName == null ? 'fNameError' : null"
              />
              <span
                class="error"
                role="alert"
                id="fNameError"
                v-if="showErrorMessages && fName == null"
                :aria-label="translate('Login.error.fname')"
                >{{ translate("Login.error") + " " + translate("Login.error.fname") }}</span
              >
            </div>
          </div>

          <!-- Terms of Use -->
          <div v-if="getClientConfig.clientname != 'texas'" class="pt-2">
            <p>
              <!-- {{ translate("Login.termsofUse") }}
              <a href="#" @click="openResource(termsofUse)"> {{ translate("App.TOU") }} </a>. -->
              <span v-html="combinedTOU()"></span>
              <span class="sr-only">{{ $t("LoginLinks.newwindow") }}</span>
            </p>
          </div>
          <Button
            id="btn_sign_in"
            :disabled="snackbar"
            :label="
              getClientConfig.clientname === 'texas'
                ? translate('Login.Signon')
                : translate('Login.Signin')
            "
            @click="onSignInClick($event)"
          />
        </fieldset>
      </form>
    </div>
    <LoginPopupLinks v-if="getClientConfig.clientname === 'texas'" />

    <LoginLinks v-else />
  </div>
  <!-- </div> -->
</template>

<style>
.darker-placeholder .p-placeholder {
  color: #605e5c !important;
}
</style>
<style scoped>
.darker-placeholder::placeholder {
  color: #605e5c !important;
}

.main_wrapper .grid {
  margin-left: 0;
  margin-right: 0;
}
.outerWrapper {
  padding: 0;
}
#mainWrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  max-width: 900px;
  margin: auto;
  padding: 0 1.25rem;
  position: relative;
}
.texas #mainWrapper {
  max-width: 552px;
  padding: 0;
  width: 100%;
}

/* Header */
.CAIHeader {
  align-items: flex-end;
  color: #005e9e;
  display: flex;
  justify-content: space-between;
}
.CAIHeader .branding {
  display: flex;
  align-items: center;
}
.CAIHeader .logo {
  background: url("../assets/images/calogo.svg") no-repeat;
  display: inline-block;
  height: 35px;
  margin-right: 0;
  padding: 0;
  text-decoration: none;
  width: 115px;
}
.CAIHeader .logo:hover {
  color: inherit;
  text-decoration: none;
}
.CAIHeader .logo.markonly {
  background: url("../assets/images/calogo.svg") no-repeat;
  padding: 0.5em 0 0 50px;
}
.CAIText {
  font-size: 0.688em; /*11px*/
  font-weight: 400;
  line-height: 10px;
  text-align: center;
}
.CAIText span {
  color: #2c9ed9;
}
/* .CAIHeader .systemName {
  border-left: 1px solid #005e9e;
  font-size: 2.125em;
  font-weight: 300;
  margin: 0 0 0 0.5em;
  padding: 0 0 0 0.5em;
} */
.CAIHeader .userbar {
  margin: 0;
  padding: 0;
  font-size: 0.8em;
  line-height: 18px;
  text-align: right;
}

.florida .CAIHeader .CAIText {
  display: none;
}
.florida .CAIHeader .logo {
  background: url("../assets/images/florida_logo.svg") no-repeat;
  background-size: contain;
  height: 50px;
  padding: 0;
  width: 151px;
}
.alertContent {
  width: 350px;
  margin: 0 auto;
  text-align: left;
}
.branding {
  border: 1px solid #ccc;
  border-bottom-color: #fff;
  border-radius: 10px 10px 0 0;
  padding: 1em 1em 0;
  z-index: 1;
}

@media print {
  .CAIHeader .logo.markonly {
    content: url("../assets/images/CA-Logo_CLR_Horz.svg");
  }
  .CAIHeader .userbar {
    display: none;
  }

  .florida .CAIHeader .CAIText {
    display: none;
  }
  .florida .CAIHeader .logo {
    content: url("../assets/images/florida_logo.svg");
  }
}

/*Login*/
.loginDateContainer {
  flex: 1 0 auto;
}
.loginDateContainer .selectContainer:first-child {
  width: 40%;
}
/* texas */
.texas .loginDateContainer .selectContainer {
  width: 33.3333%;
}

.loginDateContainer label {
  font-size: 0.75rem;
  font-weight: 400;
  margin-top: -1rem;
}

#btn_sign_in {
  /* height: 36px; */
  /* width: 96px; */
  padding: 0.5rem 1rem;
  margin: 1.5rem auto;
  text-transform: uppercase;
  align-items: center;
  color: #fff;
  display: flex;
  flex: 1 0 auto;
  justify-content: inherit;
  line-height: normal;
  position: relative;
  background-color: #1976d2 !important;
  border-radius: 0.25rem;
}
.texas #btn_sign_in {
  background-color: #00486e !important;
  /* width: initial; */
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.texas #btn_sign_in:hover {
  background-color: #27587b !important;
  border: 1px solid #27587b !important;
}
#btn_sign_in:hover {
  background-color: #6598dd !important;
  border: 1px solid #6598dd !important;
}

#btn_sign_in:deep(span) {
  letter-spacing: 0.0892857143em;
  font-weight: 500;
  font-size: 1rem;
}
.loginFieldContainer {
  padding: 1.5rem 0;
}
.dialog_close {
  color: inherit !important;
}
.dialog_content_position {
  padding: 2rem;
}
.dialog_width {
  width: "50vw";
  overflow: hidden;
}

.access-row {
  display: flex;
  align-items: flex-start;
  flex-flow: column nowrap;
  gap: 0.5rem;
  padding: 0.5rem 0 0;
}
.field {
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  width: 100%;
}

/* Label styling - looks like a small pill/strip above the input */
.field-label {
  margin: 0 0 0.25rem;
}

/* small label row for label + info button */
.label-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.info-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
.svg-icon-info {
  background-color: var(--bs-white);
  display: block;
  height: 1rem;
  -webkit-mask-image: var(--svg-icon-info);
  mask-image: var(--svg-icon-info);
  transition: all 0.35s linear;
  width: 1rem;
}

/* Input shared styles */
.field-input {
  width: 100%;
  max-width: 100%;
  padding: 0.4375rem 0.4375rem;
  border-radius: 0.25rem;
  border: none;
}

/* left input appears white (default) */
.field-input:not(.tsds-input) {
  background: var(--bs-white);
  color: #323130;
}

/* TSDS input: default "grayout" look until focused or has value */
.tsds-input.grayout {
  background: #8ab1cd; /* muted bluish gray from screenshot */
  color: var(--bs-black);
}

/* When TSDS is focused or has content remove grayout */
.tsds-input:focus,
.tsds-input:not(.grayout) {
  background: var(--bs-white);
  color: #323130;
  border-color: #9fb6c4;
  outline: none;
  box-shadow: 0 0 0 3px rgba(46, 134, 171, 0.08);
}

/* separator with vertical pipe and 'or' */
.separator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 0.75rem;
  text-align: center;
  user-select: none;
  gap: 6px;
}

/* vertical pipe styling */
.pipe {
  font-weight: 700;
  color: #cfd8dc;
  font-size: 18px;
  line-height: 1;
}

/* small or text */
.or-text {
  color: var(--bs-white);
  font-size: 0.875rem;
  margin: -1rem 0 0 1.25rem;
  position: relative;
}
.or-text::after,
.or-text::before {
  background: #fcfcfc70;
  content: "";
  height: 1px;
  left: -1.25rem;
  position: absolute;
  top: 50%;
  width: 1rem;
}
.or-text::after {
  left: auto;
  right: -1.25rem;
}

.p-dialog.tsds-id-modal .dialog_content_position {
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.5rem !important;
}

.texas .loginFieldContainer {
  padding: 0;
}
.loginFieldContainer:deep(input),
.loginFieldContainer:deep(.p-dropdown) {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid gray;
}
.texas .loginFieldContainer:deep(input),
.texas .loginFieldContainer:deep(.p-dropdown) {
  border: none;
  border-radius: 4px;
}
.loginFieldContainer .labelcontainer {
  color: #000;
}
.loginFieldContainer:deep(input::placeholder) {
  font-size: 1.2em;
  color: rgba(0, 0, 0, 0.4);
}

.texas .login_form .labelcontainer:first-child {
  width: 100%;
}
.texas .login_form .labelcontainer {
  color: #fff;
}
.texas .loginFieldContainer {
  flex-direction: column;
}
.texas .col-6 {
  width: 50%;
}
.texas .col-8 {
  width: 100%;
}

#login_info {
  border: 1px solid #ccc;
  border-radius: 0 10px 0 0;
  padding: 1rem;
}
:root[dir="rtl"] #login_info {
  border-radius: 10px 0 0 0;
}
.texas #login_info {
  background: #367aab;
  border: none;
  border-radius: 0;
  color: #fff;
  margin-top: 0;
  padding: 0;
}
#login_info .login_form {
  margin: 0 auto;
  padding: 0 1rem;
  width: 70%;
}
.texas #login_info .login_form {
  width: 100%;
}
fieldset {
  display: flex;
  flex-flow: column nowrap;
}
.login_form legend {
  color: #000;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0;
}
#dobFieldset {
  position: relative;
}
#dobFieldset legend {
  font-size: 1rem;
}
body.texas .login_legend {
  display: none;
}
.login_form .login_note {
  font-size: 0.9rem;
  margin: 0 0 0.5rem;
}
.texas .login_form .login_note {
  font-size: 0.75rem;
  font-weight: 200;
}
.login_form p {
  margin: 0;
}
.v-text-field {
  margin-top: 0;
  padding-top: 0;
}

.labelcontainer {
  font-weight: bold;
  padding: 0.5rem 0 0;
  flex: 0 0 25%;
}
.texas .labelcontainer {
  flex: 1 1 100%;
  font-weight: normal;
  margin: 0 0 0.25rem;
  max-width: 100%;
}
.fieldcontainer {
  padding-top: 0;
}
.texas .fieldcontainer {
  flex: 1 1 100%;
  max-width: 100%;
  padding: 0;
}
.texas .fieldcontainer.v-col-2,
.texas .fieldcontainer.v-col-3,
.texas .fieldcontainer.v-col-4 {
  flex: 1 1 calc(33% - 0.25rem);
  margin-right: 0.5rem;
  max-width: calc(33% - 0.25rem);
}
.texas .fieldcontainer.v-col-3 {
  margin-right: 0;
}

.fieldcontainer .v-input--is-focused label {
  top: 2px;
}

.texas .v-text-field input {
  background-color: #fff !important;
  border-radius: 4px !important;
}
.texas .theme--light.v-input input,
.texas .theme--light.v-input textarea {
  background: #fff;
}

footer {
  border-top: none;
  margin: 0;
}
.texas .loginpage.v-application .error--text,
.texas .loginpage .v-btn--outlined .v-btn__content .v-icon,
.texas .loginpage .v-btn--round .v-btn__content .v-icon {
  color: #fff !important;
  caret-color: #fff !important;
}

.error {
  color: #c42112;
  display: block;
  font-weight: 700;
  max-width: 200px;
  position: relative;
  top: 0.25rem;
}
.texas .error {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.2rem;
  padding: 0.1rem 0.25rem;
}

@media (max-width: 500px) {
  #mainWrapper {
    padding: 0;
    width: 100%;
  }
  #login_info {
    border-radius: 0;
    padding: 0;
  }
  .texas #login_info {
    padding-top: 0.5rem;
  }
  #login_info .login_form {
    margin: 0;
    width: 100%;
  }
  #login_info .v-row .labelcontainer {
    flex: 100% !important;
    max-width: 100% !important;
  }
  #login_info .v-row .fieldcontainer.v-col.v-col-6,
  #login_info .v-row .fieldcontainer.v-col.v-col-7 {
    flex: 100%;
    max-width: 100%;
    padding: 0;
  }
  #login_info .v-row .fieldcontainer.v-col.v-col-4,
  #login_info .v-row .fieldcontainer.v-col.v-col-2,
  #login_info .v-row .fieldcontainer.v-col.v-col-3 {
    padding: 0 1.5rem 0 0;
    flex: 1 1 calc(33% - 0.5rem);
    max-width: calc(33% - 0.25rem);
  }
  .texas #login_info .v-row .fieldcontainer.v-col-2,
  .texas #login_info .v-row .fieldcontainer.v-col-3,
  .texas #login_info .v-row .fieldcontainer.v-col-4 {
    padding: 0;
  }
  .alertContent {
    width: 100%;
  }
  .col-6,
  .col-8,
  .w-2,
  .w-3,
  .w-4,
  .texas .loginDateContainer .w-2,
  .texas .loginDateContainer .w-3,
  .texas .loginDateContainer .w-4,
  .selectContainer {
    padding-bottom: 0.5rem;
    width: 100% !important;
  }
  .loginFieldContainer {
    padding: 0.5rem 0;
  }
  .loginDateContainer {
    flex-flow: column nowrap;
  }
  .labelcontainer {
    padding: 0.25rem 0;
  }
  #btn_sign_in {
    height: inherit;
    padding: 1rem;
    width: 100%;
  }
  #login_help {
    flex-flow: column nowrap;
  }
}

@media (max-width: 470px) {
  #login_info fieldset {
    min-width: 100%;
  }
}

@media only screen and (max-width: 767px) {
  #mainWrapper {
    padding: 0;
  }
  #login_info {
    border-radius: 10px 10px 0 0;
  }
  #login_info .login_form {
    width: 100%;
  }
  .login_form .loginFieldContainer {
    flex-direction: column;
  }
  .login_form .labelcontainer.col-3 {
    width: 100%;
  }
  .error {
    max-width: inherit;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  #login_info .login_form {
    width: 100%;
  }
  .error {
    max-width: 150px;
  }
}

@media screen and (min-width: 375px) {
  .field.id-field {
    flex: 1 1 35%;
  }
}
@media screen and (min-width: 500px) {
  .access-row {
    flex-flow: row nowrap;
    gap: 0.875rem;
    justify-content: space-between;
  }
  .field {
    max-width: 260px;
  }
  .field.id-field {
    max-width: 176px;
  }
  .or-text {
    margin: 1.5rem 0 0;
  }
  .or-text::after,
  .or-text::before {
    height: 1rem;
    left: 50%;
    top: -1rem;
    width: 1px;
  }
  .or-text::after {
    top: auto;
    bottom: -1.1rem;
  }
}
@media screen and (min-width: 768px) {
  #dobFieldset legend {
    position: absolute;
    top: 50%;
    width: 25%;
  }
  body.texas #dobFieldset legend {
    position: static;
    width: 100%;
  }
  .loginDateContainer {
    margin-left: 25%;
  }
  body.texas .loginDateContainer {
    margin-left: 0;
  }
}

.sr-only {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
